import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import IntegrationEquipmentSync from '../IntegrationEquipmentSync';
import {
  autoImportHeader,
  autoImportUncheckText,
} from '../integrationHelpers';

const autoImportContent = (
  <div style={{ width: 500 }}>
    {autoImportHeader('Sage', 'Equipment')}
    <br /><br />1. Only active Equipment will be imported from Sage
    <br /><br />2. The Sage Equipment Name will be used as the Ontraccr Equipment Name
    <br /><br />{autoImportUncheckText('Sage')}
  </div>
);

const importHelpText = (
  <div style={{ width: 500 }}>
    Select from this dropdown to either <b>Import</b> new Equipment from Sage
    or <b>Link</b> Sage Equipment to existing Ontraccr Equipment
    <br /><br /> <b>Import:</b> Equipment must have a name to be imported into Ontraccr.
    <br /> <b>Link:</b> Select an existing Ontraccr Equipment to link with the Sage Equipment.
  </div>
);

export default function SageEquipmentSync({
  onEquipmentChanged,
  importEquipment,
  divisionFilter,
}) {
  const {
    sageData: {
      equipment: sageEquipment,
    } = {},
  } = useSelector((state) => state.settings);

  return (
    <IntegrationEquipmentSync
      integrationEquipment={sageEquipment}
      title="Sage"
      integrationKey="sageId"
      onEquipmentChanged={onEquipmentChanged}
      autoImportContent={autoImportContent}
      importHelpText={importHelpText}
      importEquipment={importEquipment}
      divisionFilter={divisionFilter}
    />
  );
}

SageEquipmentSync.propTypes = {
  onEquipmentChanged: PropTypes.func,
  importEquipment: PropTypes.shape({
    importList: PropTypes.arrayOf(PropTypes.shape({})),
    linkDeletedList: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])),
  }),
  divisionFilter: PropTypes.instanceOf(Set),
};

SageEquipmentSync.defaultProps = {
  onEquipmentChanged: () => {},
  importEquipment: {},
  divisionFilter: null,
};
